export const DOWNLOAD_CONFIGURATION_TEXT = {
    id: 'oe.website.downloadConfiguration',
    description: 'button label',
    defaultMessage: 'Download Configuration'
};

export const UPLOAD_CONFIGURATION_BUTTON_TEXT = {
    id: 'oe.website.uploadConfiguration',
    description: 'Button label',
    defaultMessage: 'Upload Configuration'
};

export const UPDATE_WEBSITE_TEXT = {
    id: 'oe.website.update',
    defaultMessage: 'Update Website',
    description: 'Button text'
};

export const UPLOAD_CONFIGURATION_LABEL_TEXT = {
    id: 'oe.website.uploadConfiguration',
    defaultMessage: 'Upload Configuration',
    description: 'Label text'
};

export const CONFIGURATION_DOWNLOAD_IN_PROGRESS_TEXT = {
    defaultMessage: 'Configuration Download in Progress',
    description: 'Toast label',
    id: 'oe.website.configurationDownloadInProgress'
};

export const PASSPORT_URL_TEXT = {
    id: 'oe.passport.passportUrl',
    defaultMessage: 'PASSPORT URL',
    description: 'Label text',
};
